import './CSS/vram.scss';
import vramGeneral from './Assets/VRAM_General.svg';
import blocSchema from './Assets/StructureCaractèreV2.svg';

export default function RamVideo()

{
    return(
        <div className='Page'>
            <h1>La RAM vidéo</h1>

            <p>
                Autant vous prévenir tout de suite, cette partie est extrêmement importante.<br/>
            </p>
            <p>
                Comme déjà dit dans l'introduction, le VG5000 possède une RAM lue par le Z80, mais une autre RAM est elle reservée au VDP qui est donc le seul à y accéder.<br/>
                Cette VRAM aurait pu faire 16Ko car le VDP sait gérer cette dimension. Cependant les concepteurs de la machine ont cru bon de ne lui allouer que la moitié, soit 8Ko...<br/>
                Je ne sais s'il est possible en interne d'ajouter ces 8Ko manquant, toujours est-il que c'est impossible via le port extension et que par conséquent, 
                sans modification de la machine en elle même il ne sera pas possible d'en ajouter.
            </p>
            <p>
                8Ko c'est cependant déjà pas si mal.<br/>
                En effet, même si cela peut sembler peu, rappelons que notre EF9345 fonctionne en mode caractères.<br/>
                Cela signifie que par exemple, dans un monde idéal, un seul octet peut suffire pour donner le numéro d'un caractère à l'écran.<br/>
                Bien entendu, vous vous en doutez, cela sera un peu plus compliqué dans la réalité.
            </p>

            <h2>Division principale</h2>

            <p>
                Notre VRAM est divisée en plusieurs morceaux de 1Ko (1024 octets).<br/>
                Nous nommerons ces parties des <strong>BLOCS</strong>. 
                Nous pourrons allouer à chaque bloc un "rôle". Par exemple au démarrage, les blocs 0, 1 et 2 sont reservés à l'écran.<br/>
                Ce rôle peut donc soit être l'écran et ses attributs, soit une table de caractères.
            </p>

            <p>
            <img className="VramGeneralSchema" src={vramGeneral} alt="VRAM Général Schéma"  />
            </p>

            <h2>Divisions des blocs</h2>

            <p>
                Chaque bloc sera lui même divisé en plusieurs groupes de 40 octets que nous nommerons <strong>BUFFERS</strong>.<br/>
                Ces buffers sont au nombre de 26 contiendront donc des octets numérotés de 0 à 39.
            </p>

            <p>
                Hors si vous comptez bien, vous vous rendrez compte que 40 octets * 26 buffers = 1040.<br/>
                Nous débordons donc de la limitation de 1Ko par bloc.<br/>
                Une particularité de cette configuration est qu'un des buffers: le numéro 1 fais parfois 24 octets de long (nous y reviendrons).
            </p>

            <p>
                Notez enfin que la numérotation des buffers est particulière.<br/>
                Si les deux premiers buffers sont les numéros 0 et 1, les suivants seront numérotés de 8 à 31. 
            </p>

            <p>
                Voici un schémas rapide représentant un bloc complet:<br/>
                Y correspond au numéro de buffer, tandis que X correspond au numéro d'octet.
            </p>

            <p>
            <img className="blocSchema" src={blocSchema} alt="Bloc Schéma" />
            </p>


        </div>
    )
}